<template>
    <div class="list-group-item border-top-0 position-relative" :class="rowClass"
        style="cursor: pointer"
        @click="$emit('click')"  
        @keyup.enter="$emit('click')"
        @contextmenu.prevent="handleRightClick()">
        <div class="row">
            <div
                v-for="col in cols"
                :class="`col-xs-12 col-${breakpoint}-${col.size}`"
                v-bind:key="col.key"
            >
                <div class="p-0 mb-0" :class="`d-${breakpoint}-none`" style="font-size: 0.7em;">
                    {{ col.heading}}
                </div>
                <div class="mt-0 mb-1" style="overflow: hidden; text-overflow: ellipsis">
                    {{ col.cb ? col.cb(item) : item[col.key] }}
                </div>
            </div>
        </div>

        <!-- Action Buttons (appended at end for row-view) -->
        <div :class="`d-none d-${breakpoint}-block position-absolute`" style="top: 50%; right: 1rem; transform: translateY(-50%)">
            <slot name="actions">
                <button
                    v-if="showEdit" 
                    class="btn btn-sm btn-primary"
                    :class="{ 'mr-3 px-3': showDelete }" 
                    style="cursor: pointer"
                    @click.stop="$emit('edit', item)"
                >
                    {{ $t('edit') }}
                </button>
                <button 
                    v-if="showDelete || rightClicked" 
                    class="btn btn-sm btn-danger"
                    @click.stop="$emit('delete', item)"
                >
                    {{ $t('delete') }}
                </button>
            </slot>
        </div>

        <!-- Action Buttons (appended at bottom for block-view) -->
        <div :class="`d-block d-${breakpoint}-none mt-2`">            
            <slot name="actions">
                <button
                    v-if="showEdit" 
                    class="btn btn-sm btn-primary"
                    :class="{ 'mr-2 px-3': showDelete }" 
                    style="cursor: pointer"
                    @click.stop="$emit('edit', item)"
                >  
                {{ $t('edit') }}
                </button>
                <button 
                    v-if="showDelete || rightClicked" 
                    class="btn btn-sm btn-danger"
                    @click.stop="$emit('delete', item)"
                >
                {{ $t('delete') }}
                </button>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        breakpoint: String,
        cols: Array,
        item: Object,
        showEdit: Boolean,
        showDelete: Boolean,
        allowRightClick:Boolean,
        rowClass: String,
    },
    data() {
        return {
            rightClicked:false
        }
    },
    methods:{
        handleRightClick(){
            if(this.allowRightClick) this.rightClicked = !this.rightClicked;  
        }
    }
}
</script>
